import { Spin } from "antd";
import React from "react";

const SpinLoader = () => {
  return (
    <div className="spin-center">
      <Spin className="spin_loader" size="large" />{" "}
    </div>
  );
};

export default SpinLoader;
